import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function containerNameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
            return null;
        }
        const pattern = /^[$a-zA-Z0-9](?!.*--)[-a-zA-Z0-9]{1,61}[a-zA-Z0-9]$/;
        return pattern.test(value) ? null : { invalidContainerName: true };
    };
}

export function storageAccountValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
            return null;
        }
        const pattern = /^[a-zA-Z0-9]{3,24}$/;
        return pattern.test(value) ? null : { invalidStorageAccount: true };
    };
}

export function dfsDomainValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
            return null;
        }
        const pattern = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
        return pattern.test(value) ? null : { invalidDfsDomain: true };
    };
}

export function jdbcUrlCredentialsValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
            return null;
        }
        const passwordPattern = /[;&?]?(PWD|password)\s*=\s*[^;&]+/i;
        const embeddedCredentialsPattern = /:\/\/[^:]+:[^@]+@/;

        return passwordPattern.test(value) || embeddedCredentialsPattern.test(value)
            ? { credentialsInUrl: true }
            : null;
    };
}
